import { render, staticRenderFns } from "./ForAgents.vue?vue&type=template&id=72423242&"
import script from "./ForAgents.vue?vue&type=script&lang=js&"
export * from "./ForAgents.vue?vue&type=script&lang=js&"
import style0 from "./ForAgents.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports